export enum PROFILES {
  ADMINISTRADOR = 'ADMINISTRADOR',
  COMUN = 'COMUN',
  JUBILADO = 'JUBILADO'
}
